module.exports = __webpack_public_path__ + "img/2.abfd2f01.jpg";